import { useState } from "react";

import { useCurrentAuthUser } from "../../auth";
import { canUsePermission } from "../../../lib/auth";
import { useDicMajorRuntime } from "../runtime/useDicMajorRuntime";
import type { DicMajorAliasItem, DicMajorItem } from "../types";
import { DicMajorFilterPanel } from "./DicMajorFilterPanel";
import { DicMajorMutationModal } from "./DicMajorMutationModal";
import { DicMajorResultTable } from "./DicMajorResultTable";

type ModalState =
  | { type: "major-create" }
  | { type: "major-edit"; major: DicMajorItem }
  | { type: "alias-create"; major: DicMajorItem }
  | { type: "alias-edit"; major: DicMajorItem; alias: DicMajorAliasItem };

/** 标准专业字典页面主体。 */
export function DicMajorFeaturePage() {
  const runtime = useDicMajorRuntime();
  const currentUser = useCurrentAuthUser().data;
  const canManage = canUsePermission(currentUser, "dictionary.major:manage");
  const [modalState, setModalState] = useState<ModalState | null>(null);

  return (
    <main className="dic-major-page">
      <DicMajorFilterPanel
        filters={runtime.draftFilters}
        errorMessage={runtime.errorMessage}
        onChange={runtime.setDraftFilters}
        onReset={runtime.handleReset}
        onSearch={runtime.handleSearch}
      />
      <DicMajorResultTable
        canManage={canManage}
        items={runtime.items}
        loading={runtime.loading}
        page={runtime.page}
        pageSize={runtime.pageSize}
        total={runtime.total}
        onCreateMajor={() => setModalState({ type: "major-create" })}
        onEditMajor={(major) => setModalState({ type: "major-edit", major })}
        onCreateAlias={(major) => setModalState({ type: "alias-create", major })}
        onEditAlias={(major, alias) => setModalState({ type: "alias-edit", major, alias })}
        onDeleteAlias={runtime.handleDeleteAlias}
        onPageChange={runtime.handlePageChange}
        onPageSizeChange={runtime.handlePageSizeChange}
      />
      <DicMajorMutationModal
        state={modalState}
        onClose={() => setModalState(null)}
        errorMessage={runtime.mutationErrorMessage}
        onCreateMajor={runtime.handleCreateMajor}
        onUpdateMajor={runtime.handleUpdateMajor}
        onCreateAlias={runtime.handleCreateAlias}
        onUpdateAlias={runtime.handleUpdateAlias}
        onClearError={runtime.clearMutationError}
      />
    </main>
  );
}
